// extracted by mini-css-extract-plugin
export default {"gamesNavItem":"styles_gamesNavItem__S9kkn","active":"styles_active__quqwH"};